import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import NavBar from "../components/NavBar";
import HeroBanner from "../components/HeroBanner";
import ServiceCarousel from "../components/ServiceCarousel";
import Hero from "../components/Hero";
import Benefits from "../components/Benefits";
import Technology from "../components/Technology";
import Features from "../components/Features";
import Trust from "../components/Trust";
import WhyXega from "../components/WhyXega";
import ContactGlobal from "../components/ContactGlobal";
import Footer from "../components/Footer";
import FloatingWhatsApp from "../components/FloatingWhatsApp";
import IntroAnimation from "../components/IntroAnimation";
import { api } from "../lib/api";

export default function Home() {
  const [content, setContent] = useState(null);
  const [introDone, setIntroDone] = useState(() => !!localStorage.getItem("xega_intro_shown"));
  const location = useLocation();

  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data?.data || null)).catch(() => {});
    api.post("/track/visit", { path: "/" }).catch(() => {});
  }, []);

  // Smooth-scroll to an anchor when arriving via /#contact from another page.
  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.replace("#", "");
    // Wait for sections to mount before scrolling.
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 400);
    return () => clearTimeout(t);
  }, [location.hash, introDone]);

  return (
    <div className="min-h-screen text-white" data-testid="landing-page">
      {!introDone && <IntroAnimation onDone={() => setIntroDone(true)} />}
      <NavBar contact={content?.contact} />
      <HeroBanner />
      <ServiceCarousel />
      {/* Hidden per client request (Feb 26, 2026) — kept in code so we can restore later
      <WhyXega content={content} />
      <Technology />
      <Features />
      <Trust />
      */}
      <ContactGlobal />
      <Footer content={content} />
      <FloatingWhatsApp phone={content?.contact?.whatsapp} />
    </div>
  );
}
